import { Typography, useTheme } from '@mui/material';
import styles from './heading.module.scss';

export function Heading(props: any) {
  const theme = useTheme();

  return (
    <div className={`${styles.headingContainer}`}>
      <Typography
        sx={{
          color: '#101828',
          fontFamily: 'Poppins',
          fontSize: '30px',
          fontWeight: 600,
          [theme.breakpoints.down(1601)]: {
            fontSize: '28px',
          },
          [theme.breakpoints.down(1441)]: {
            fontSize: '24px',
          },
          [theme.breakpoints.down(1367)]: {
            fontSize: '20px',
          },
        }}
        data-testid="heading-title"
      >
        {props.title}
      </Typography>
    </div>
  );
}
